import React from 'react';
import PropTypes from 'prop-types';

export default function ChevronRight(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill={props.fill} strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
  );
}

ChevronRight.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  fill: PropTypes.string
};

ChevronRight.defaultProps = {
  color: '#202020',
  width: 16,
  fill: 'none'
};